import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const GET_USER_IDENTIFICATION_LOGS = 'GET_USER_IDENTIFICATION_LOGS';

const apiCall = createApiCall(GET_USER_IDENTIFICATION_LOGS, params => ({
  endpoint: generateEndpoint({
    host: `/api/admin/user-identification-logs`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
